import { Grid } from '@material-ui/core';
import React, { Component } from 'react';
import packageJson from '../../package.json';
import { ThemeSetContext } from './ThemeSet';

class Footer extends Component {
    static contextType = ThemeSetContext;
    constructor(props) {
        super(props);
    }
    render() {
        const themeColor = this.context.themeColor;
        return (
            <Grid container={true} className="MuiGrid-container Footer">
                <p>
                    {"Copyright © "}{new Date().getFullYear() + " "}
                    <a target="_blank" rel="noreferrer noopener" color="inherit" href="https://www.genesys-tech.com">
                        {"Genesys Technology Ltd."}
                    </a>
                    {"All rights reserved. "}
                </p>
                <p>
                    <span style={{ color: themeColor.primary, paddingRight: "10px" }}>ver{packageJson.version}</span>
                    {"Made by "}
                    <a target="_blank" rel="noreferrer noopener" href="https://www.genesys-tech.com">Genesys Technology Ltd.</a>
                </p>
            </Grid>
        )
    }
}
export default Footer;